// @flow
import moment from 'moment';
import React, { Component } from 'react';

import { isBrowser } from '../../lib/utils';

import '../../../node_modules/flatpickr/dist/themes/airbnb.css';

let Flatpickr = '';

if (isBrowser()) Flatpickr = require('react-flatpickr').default;

type Props = {
  range?: boolean,
  dateFormat?: string,
  defaultDate?: string | Array<string>,
  onDateChange: (date: string | Array<string>) => void,
  notInline?: boolean,
};

export default class DatePicker extends Component<Props> {
  static defaultProps = {
    dateFormat: 'YYYY-MM-DD',
  };

  render() {
    return (
      isBrowser() && (
        <Flatpickr
          id="flatpickr"
          placeholder="YYYY-MM-DD"
          options={{
            inline: !this.props.notInline,
            minDate: 'today',
            disableMobile: 'true',
          }}
          onChange={this.handleDateChange}
        />
      )
    );
  }

  handleDateChange = date => {
    const { formatDate, props } = this;
    const { range, onDateChange } = props;

    if (range) {
      date = [formatDate(date[0]), formatDate(date[1])];
      return onDateChange(date);
    } else {
      date = formatDate(date[0]);
      return onDateChange(date);
    }
  };

  formatDate = (date: string) => moment(date).format(this.props.dateFormat);
}



// WEBPACK FOOTER //
// ./src/components/UI/DatePicker.jsx